import api, { transformResponse } from "services/api";

export const udfApi = api
  .enhanceEndpoints({ addTagTypes: ["ClientUdfCustomField"] })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchAllClientUdfCustomFields: build.query({
        query: () => `/api/v1/common/client-custom-fields/`,
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? // successful query
              [
                ...results.map(({ id }) => ({ type: "ClientUdfCustomField", id })),
                { type: "ClientUdfCustomField", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'ClientUdfCustomField', id: 'LIST' }` is invalidated
              [{ type: "ClientUdfCustomField", id: "LIST" }],
      }),
    }),
  });

export const { useFetchAllClientUdfCustomFieldsQuery } = udfApi;
